import { EventEmitter } from 'events'

class NetworkMonitor extends EventEmitter {
  // connect, disconnect, change events are emitted

  then = Infinity // future
  tickDuration = 60 * 1000 // 1 minute
  sleepDuration = 10 * this.tickDuration // 10 minutes
  shouldConnect: boolean = false
  interval?: NodeJS.Timeout

  constructor() {
    super()
    this.monitorSleep()
    window.addEventListener('online', this.online)
    window.addEventListener('offline', this.offline)
    window.addEventListener('focus', this.focus)
  }

  log(...args: unknown[]) {
    console.log(`%c${args[0]}`, 'color:red;font-weight:bold', ...args.slice(1))
  }

  monitorSleep() {
    this.interval = setInterval(this.tick, this.tickDuration)
    this.then = Date.now()
  }

  isActive() {
    return document.hasFocus() && navigator.onLine
  }

  tick = () => {
    const now = Date.now()
    if (now - this.then > this.sleepDuration) this.awake()
    this.then = now
  }

  awake = () => {
    this.log('WAKE')
    this.shouldConnect = true
    this.connect()
  }

  focus = () => {
    this.connect()
  }

  offline = () => {
    if (navigator.onLine) return
    // dispatch.ui.set({
    //   offline: { title: 'Disconnected', message: 'Internet access is required.', severity: 'warning' },
    // })
    this.shouldConnect = true
    this.log('DISCONNECT')
    this.emit('disconnect')
  }

  online = () => {
    if (!navigator.onLine) return
    // dispatch.ui.set({ offline: undefined })
    this.log('ONLINE')
    this.connect()
  }

  connect = () => {
    if (this.shouldConnect && this.isActive()) {
      this.shouldConnect = false
      this.log('CONNECT')
      this.emit('connect')
    }
  }

  emit(event: string | symbol, ...args: unknown[]) {
    super.emit('change', ...args)
    super.emit(event, ...args)
    return true
  }
}

export default new NetworkMonitor()
